import React, { useCallback } from 'react';
import MultiInput from '../../../Shared/MultiInput/MultiInput';
import ModalLink from '../../../Shared/Modal/ModalLink/ModalLink';

import { UNIT } from '../../../../settings/settings';
import { ROTH_DAILY_MINIMUM_MAXIMUM } from '../../../../redux/modules/modals/modals.module';
import { calculateGrossAmountDollars } from '../../../../utils/funds/typed-funds-utility';
import { rothConversionFundInputCloseoutWatcher } from '../../../../utils/funds/funds-utility';
import ConvertAllRemaining from './ConvertAllRemaining';

import './RothConversionFundEditor.scss';
import { useSelector } from 'react-redux';
import { getProgressCurrentStep } from '../../../../redux/modules/progress';

const RothConversionFundEditor = ({
  fund,
  handleFundAllocations,
  openModal,
}) => {
  const { name, grossAmount, selected, fundLimitMessage, closeout, error } =
    fund;

  const currentStep = useSelector(getProgressCurrentStep);
  const allowedUnits = [UNIT.DOLLARS, UNIT.PERCENT, UNIT.SHARES];

  /**
   * Amount Input change callback
   */
  const onAmountChange = useCallback(
    (amount) => {
      const unit = fund.grossUnit || UNIT.DOLLARS;
      handleFundAllocations(fund, {
        type: 'AMOUNT',
        customProps: {
          grossAmount: amount,
          grossUnit: unit,
          grossAmountDollars: calculateGrossAmountDollars(
            fund.equityAsOf,
            amount,
            unit,
            fund.sharePrice
          ),
        },
      });

      // Add a watcher to show closeout modal when needed
      fund.equityAsOf !== 0 &&
        rothConversionFundInputCloseoutWatcher(
          amount,
          fund,
          openModal,
          handleFundAllocations
        );
    },
    [fund, handleFundAllocations, openModal]
  );
  return (
    <div className="fund-editor-wrapper roth-conversion-fund-editor">
      <div className="multi-input-wrapper">
        <div className="title">Amount</div>
        <div className="editor-flex-wrapper">
          <MultiInput
            allowedUnits={allowedUnits}
            ariaLabel={`Allocate Amount for ${name}`}
            autoFocus={selected}
            defaultValue={closeout ? undefined : grossAmount || 0}
            validationMessage={
              <ModalLink
                link={fundLimitMessage}
                linkStyle={'dashed'}
                modalName={ROTH_DAILY_MINIMUM_MAXIMUM}
                error={error}
              />
            }
            error={error && fund.errorMessage}
            errorClassName={'error'}
            displayErrorMessage={error}
            displayValidationMessage={!error}
            inputID={`amt-${fund.agreementID}`}
            disabled={currentStep === 1 && closeout}
            onInputChange={(amount) => onAmountChange(amount)}
            onUnitChange={(unit) => {
              handleFundAllocations(fund, {
                type: 'UNIT',
                customProps: {
                  grossUnit: unit,
                  grossAmount: undefined,
                  grossAmountDollars: undefined,
                },
              });
            }}
            selectedInput={closeout ? UNIT.SHARES : fund.grossUnit}
          />
          <ConvertAllRemaining
            error={error && fund.errorMessage}
            fund={fund}
            checked={closeout}
            openModal={openModal}
            handleFundAllocations={handleFundAllocations}
          />
        </div>
      </div>
    </div>
  );
};

export default RothConversionFundEditor;
